module.exports = __webpack_public_path__ + "img/bgLine.82144d28.svg";